import axios from "axios";
import { API_ENDPOINTS } from "../../../Api/apiEndPoints"
import axiosInstance from "../../../Api/axiosInstance";
import { BASE_URL } from "../../../Api/config";

export const DCRReportFunction = async(param:any)=>{
    let response = await axiosInstance.get(API_ENDPOINTS.Reports.GET_DCR_REPORT,{params:param});
    const rowData = await response?.data;
    const formatedData = Array.isArray(rowData?.data?.data)?
    rowData.data.data.map((item:any)=>({
    Division:item.BuName,
    "Level4ReportingPosition": "500011 | Mumbai",
    "Level3ReportingPosition": "400042 | Delhi Zm",
    "Level2ReportingPosition": "300167 | Jaipur Rm",
    ReportingManagerPosition:item.Level1ReportingPosition,
    EmployeePosition:item.EmpPosition,
    "Level4ReportingEmployee": "817392 | Umesh Jaiswal | 9810065676",
    "Level3ReportingEmployee": "880480 | RAVI SRIVASTAVA | 9305039929",
    "Level2ReportingEmployee": "823759 | Hemant Sharma     | 7733933665",
    ReportingManager:item.Level1ReportingEmployee,
    EmployeeCode:item.EmployeeCode,
    EmployeeName:item.EmployeeName,
    ContactNumber:item.EmployeePhone,
    "Isjw": "No",
    JointWorkingFieldMember:item.JwEmployee,
    JointWorkingFieldMemberPosition:item.JwPosition,
    JointWorkingManagers:item.JwManagers,
    CustomerType:item.OutletType,
    CustomerCode:item.OutletCode,
    CustomerName:item.OutletName,
    CustomerTown:item.CustomerTown,
    CustomerPatch:item.CustomerPatch,
    "Agendacontroltype": "FW",
    Agenda:item.Agendname,
    ReportingTown:item.DcrTown,
    ReportingDate:item.DcrDate,
    ReportingStatus:item.DcrStatus,
    NCARemark:item.NcaComments,
    Planned:item.Planned,
    LeaveTaken:item.LeaveTaken,
    "DcrId": 7442444,
    "OutletId": 1162455,
    DCRActualCoordinates:item.DcrLatLong,
    SyncDate:item.CreatedAt,
    "UpdatedAt": "2025-09-05 17:20:37.000000"
    })):[] 

    return {rowData,formatedData};
}



export const getPositionListForDailCallReport= async(params:{page:number,limit:number,search:string})=>{
  let respone = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_POSITION_LIST,{params});
  const rowData = await respone.data; 
  const formatedData = Array.isArray(rowData.data.Positions)? rowData.data.Positions.map((item:any)=>({
    id:item.PositionId,
    label:item.PositionName
  })) :[]
  return{formatedData,rowData}
}



export const Post_DCR_version_2 = async(ReqBody:any)=>{
    //  const response =  await axios.post(`${BASE_URL}API_ENDPOINTS.Reports.POST_DRC_REPORT_VERSION_2`,ReqBody);

    //  const response = await axios.post(`${BASE_URL}${API_ENDPOINTS.Reports.POST_DRC_REPORT_VERSION_2}`, ReqBody);
    //   console.log("DERC2----------------------------->",response?.data);

      
 const response = await axios.post(
      `${BASE_URL}${API_ENDPOINTS.Reports.POST_DRC_REPORT_VERSION_2}`,
      ReqBody,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${ReqBody.apptoken}`, // ✅ optional if you use tokens
        },
      }
    );
 console.log("🚀 ~ Post_DCR_version_2 ~ response:", response)

// const response = await fetch(
//       `${BASE_URL}${API_ENDPOINTS.Reports.POST_DRC_REPORT_VERSION_2}`,
//       {
//         method: "POST",
//         headers: {
//           Origin: "https://tspc-development.truesales.in/",
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${ReqBody.apptoken}`,
//         },
//         body: JSON.stringify(ReqBody),
//       }
//     );
    
// console.log("🚀 ~ Post_DCR_version_2 ~ response:", response)


}

